module.exports = __webpack_public_path__ + "static/HazelValue2.f8f351b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HazelValue2.jpg
// module id = 396
// module chunks = 246227742792961